import { render, staticRenderFns } from "./director-account.vue?vue&type=template&id=443fc74c&"
import script from "./director-account.vue?vue&type=script&lang=ts&"
export * from "./director-account.vue?vue&type=script&lang=ts&"
import style0 from "./director-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports